import Index from "views/Index.js";
import Login from "views/screens/Login.js";
import Users from "views/screens/users/Users.js";
import UserCreate from "views/screens/users/UserCreate.js";
import Settings from "views/screens/settings/settings";
import Notifications from "views/screens/notification/notifications";
import Technicians from "views/screens/technicians/Technicians.js";
import TechnicianCreate from "views/screens/technicians/TechnicianCreate";
import TenantCreate from "views/screens/tenants/TenantCreate";
import Banner from "views/screens/banner/banner";
import Locations from "views/screens/locations/locations";
import Categories from "views/screens/categories/categories";
import Permission from "views/screens/users/Permmision.js";
import Tenants from "views/screens/tenants/Tenants";
import Expire from "views/screens/tenants/Expire.js";
import Partsinventory from "views/screens/partsinventory";
import ProductEdit from "views/screens/partsinventory/ProductEdit";
import Category from "views/screens/partsinventory/Category";
import Brands from "views/screens/partsinventory/Brands";
// import Report from "views/screens/partsinventory/report";
import Suppliers from "views/screens/partsinventory/Suppliers";
import Services from "views/screens/services/Services";
import Places from "views/screens/places/Places";
import TenantEdit from "views/screens/tenants/TenantEdit";
import Workorder from "views/screens/workorder/workorder";
import Priority from "views/screens/priority/priority";
import Time from "views/screens/priority/time";
import Days from "views/screens/priority/days";
import Reports from "views/screens/reports/Reports";
import Feedback from "views/screens/feedback/feedback";
import Reopened from "views/screens/reopened/reopened";
import Forgetpassword from "views/screens/Forgetpassword";


var routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "places1",
    component: Index,
    layout: "/admin",
    show: true
  },
  {
    path: "/workorder",
    name: "Work Order",
    icon: "workorders",
    component: Workorder,
    layout: "/admin",
    show: true
  },
  {
    path: "/reopened",
    name: "Reopened",
    icon: "reopened",
    component: Reopened,
    layout: "/admin",
    show: true
  },
  {
    path: "/reports",
    name: "Reporting",
    icon: "reports",
    component: Reports,
    layout: "/admin",
    show: true
  },

  {
    path: "/users",
    name: "Users",
    icon: "technicians",
    component: Users,
    layout: "/admin",
    show: true
  },
  {
    path: "/users/create",
    name: "UserCreate",
    icon: "assigned-technician",
    component: UserCreate,
    layout: "/admin",
    show: false
  },

  {
    path: "/technicians",
    name: "Technicians",
    icon: "technicians",
    component: Technicians,
    layout: "/admin",
    show: true
  },
  {
    path: "/technicians/create",
    name: "TechnicianCreate",
    icon: "assigned-technician",
    component: TechnicianCreate,
    layout: "/admin",
    show: false
  },
  {
    path: "/users/permission",
    name: "Permission",
    icon: "assigned-technician",
    component: Permission,
    layout: "/admin",
    show: false
  },

  {
    path: "/tenants",
    name: "Tenants",
    icon: "tenants",
    component: Tenants,
    layout: "/admin",
    show: true
  },
  {
    path: "/tenants/create",
    name: "TenantCreate",
    icon: "assigned-technician",
    component: TenantCreate,
    layout: "/admin",
    show: false
  },
  {
    path: "/tenants/edit",
    name: "TenantEdit",
    icon: "assigned-technician",
    component: TenantEdit,
    layout: "/admin",
    show: false
  },
  {
    path: "/tenants/expire",
    name: "Expire",
    icon: "assigned-technician",
    component: Expire,
    layout: "/admin",
    show: false
  },
  {
    path: "/banner",
    name: "Banner",
    icon: "banners",
    component: Banner,
    layout: "/admin",
    show: true
  },
  {
    path: "/partsinventory",
    name: "Parts Inventory",
    icon: "user-settings",
    component: Partsinventory,
    layout: "/admin",
    show: true
  },
  {
    path: "/partsinventory/edit",
    name: "ProductEdit",
    icon: "user-settings",
    component: ProductEdit,
    layout: "/admin",
    show: false
  },
  {
    path: "/partsinventory/category",
    name: "Category",
    icon: "user-settings",
    component: Category,
    layout: "/admin",
    show: false
  },
  {
    path: "/partsinventory/brands",
    name: "Brands",
    icon: "user-settings",
    component: Brands,
    layout: "/admin",
    show: false
  },
  {
    path: "/partsinventory/suppliers",
    name: "Suppliers",
    icon: "user-settings",
    component: Suppliers,
    layout: "/admin",
    show: false
  },
  // {
  //   path: "/partsinventory/report",
  //   name: "Report",
  //   icon: "user-settings",
  //   component: Report,
  //   layout: "/admin",
  //   show: false
  // },
  {
    path: "/services",
    name: "Services",
    icon: "services",
    component: Services,
    layout: "/admin",
    show: true
  },
  {
    path: "/notifications",
    name: "Notifications",
    icon: "notifications",
    component: Notifications,
    layout: "/admin",
    show: true
  },

  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    show: false
  },
  {
    path: "/forgetpassword",
    name: "Forgetpassword",
    icon: "feedbacks-1",
    component: Forgetpassword,
    layout: "/auth",
    // show:true
  },
  {
    path: "/places",
    name: "Places",
    icon: "places",
    component: Places,
    layout: "/admin",
    show: true
  },
  {
    path: "/categories",
    name: "Categories",
    icon: "categories",
    component: Categories,
    layout: "/admin",
    show: true
  },

  {
    path: "/locations",
    name: "Locations/Villas",
    icon: "loations",
    component: Locations,
    layout: "/admin",
    show: true
  },
  {
    path: "/priority",
    name: "Priority",
    icon: "priority2",
    component: Priority,
    layout: "/admin",
    show: true
  },
  {
    path: "/feedback",
    name: "Feedback",
    icon: "feedbacks-1",
    component: Feedback,
    layout: "/admin",
    show: true
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "settings",
    component: Settings,
    layout: "/admin",
    show: true
  },
  {
    path: "/priority/time",
    name: "Time",
    icon: "feedbacks-1",
    component: Time,
    layout: "/admin",
    show: false
  },
  {
    path: "/priority/days",
    name: "Days",
    icon: "feedbacks-1",
    component: Days,
    layout: "/admin",
    show: false
  },


];
export default routes;
